import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useSite } from "../context/SiteContext";
import { mediaUrl, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const { settings } = useSite();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", username: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(form);
      toast.success("Hesabın oluşturuldu!");
      navigate("/");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center relative px-4" style={{ background: "radial-gradient(ellipse at top, #2a0507 0%, #141414 55%)" }}>
      <div className="w-full max-w-md bg-black/70 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-2xl animate-fade-up">
        <Link to="/" className="flex justify-center mb-6">
          <img src={mediaUrl(settings.logo_url) || "/logo.png"} alt="logo" className="h-12" />
        </Link>
        <h1 className="text-3xl font-black text-white text-center">Aramıza Katıl</h1>
        <p className="text-center text-gray-400 text-sm mt-1 mb-6">Benzersiz kullanıcı adını al, izlemeye başla</p>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="register-name" value={form.name} onChange={set("name")} placeholder="Ad Soyad (isteğe bağlı)"
            className="w-full bg-[#2B2B2B] border border-white/10 text-white placeholder-gray-500 rounded-md px-4 py-3 focus:outline-none focus:border-[#E50914] transition-all" />
          <input data-testid="register-username" required value={form.username} onChange={set("username")} placeholder="Kullanıcı adı (@)"
            className="w-full bg-[#2B2B2B] border border-white/10 text-white placeholder-gray-500 rounded-md px-4 py-3 focus:outline-none focus:border-[#E50914] transition-all" />
          <input data-testid="register-email" type="email" required value={form.email} onChange={set("email")} placeholder="E-posta"
            className="w-full bg-[#2B2B2B] border border-white/10 text-white placeholder-gray-500 rounded-md px-4 py-3 focus:outline-none focus:border-[#E50914] transition-all" />
          <input data-testid="register-password" type="password" required value={form.password} onChange={set("password")} placeholder="Şifre (en az 6 karakter)"
            className="w-full bg-[#2B2B2B] border border-white/10 text-white placeholder-gray-500 rounded-md px-4 py-3 focus:outline-none focus:border-[#E50914] transition-all" />
          {error && <p data-testid="register-error" className="text-sm text-red-500">{error}</p>}
          <button data-testid="register-submit" type="submit" disabled={loading}
            className="w-full bg-[#E50914] hover:bg-[#F40612] text-white font-semibold py-3 rounded-md transition-all active:scale-95 disabled:opacity-60">
            {loading ? "Oluşturuluyor..." : "Kayıt Ol"}
          </button>
        </form>
        <p className="text-center text-sm text-gray-400 mt-6">
          Zaten hesabın var mı? <Link to="/login" data-testid="go-login" className="text-white font-medium hover:underline">Giriş Yap</Link>
        </p>
      </div>
    </div>
  );
}
